"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonWidget = exports.ButtonWidgetContainer = exports.makeButtonForegroundColor = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var styles = __importStar(require("./ButtonWidget.css"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var ButtonWidget_css_1 = require("./ButtonWidget.css");
var ColorUtils_1 = require("@CommonFrontendBackend/StyleServiceV2/ColorUtils");
var tokens_1 = require("@qwilr/kaleidoscope/tokens");
var pages_common_1 = require("@qwilr/pages-common");
var ButtonWidgetContainer = function (_a) {
    var className = _a.className, children = _a.children, style = _a.style;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("button-widget__container", className, styles.buttonWidgetContainer), style: style }, children));
};
exports.ButtonWidgetContainer = ButtonWidgetContainer;
var ButtonWidget = function (_a) {
    var className = _a.className, contentEditable = _a.contentEditable, children = _a.children, size = _a.size;
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("button-widget", className, styles.buttonWidget({ size: size })), contentEditable: contentEditable }, children));
};
exports.ButtonWidget = ButtonWidget;
var makeButtonForegroundColor = function (style) {
    var _a;
    var foregroundColor = (0, pages_common_1.goldilocks)(style.color.abs, {
        mode: "text",
        foregroundColor: (0, ColorUtils_1.shouldUseDarkText)(style.color.abs) ? tokens_1.palette.midnight900 : tokens_1.palette.white,
    });
    return (0, dynamic_1.assignInlineVars)((_a = {},
        _a[ButtonWidget_css_1.sharedButtonWidgetVars.foregroundColor] = foregroundColor,
        _a));
};
exports.makeButtonForegroundColor = makeButtonForegroundColor;
